import React, { Fragment, Component  } from 'react';
import "./charts.css";
import PieChartWrapper from "../../components/pie-chart-wrapper/pie-chart-wrapper-component";

class ChartsComponent extends Component {

  render() {
    const {
      topWords,
      topWordsLoading,
      topWordsError,
      sentimentBreakdown,
      sentimentBreakdownLoading,
      sentimentBreakdownError,
      primaryEmotionsBreakdown,
      primaryEmotionsBreakdownError,
      primaryEmotionsBreakdownLoading,
      reportUrl
    } = this.props;
    return (
      <Fragment>
        <PieChartWrapper
          title="Top 10 Words"
          data={topWords}
          valueName="Term"
          value="term"
          svgId="topWords"
          loading={topWordsLoading}
          link={`/report/top-words?reportUrl=${reportUrl}`}
          height={230}
          legendHeight="235px"
          minHeight="340px"
          footer
          error={topWordsError}
          linkToWord
          reportUrl={reportUrl}
        />
        <PieChartWrapper
          title="Primary Emotions Breakdown"
          data={primaryEmotionsBreakdown}
          valueName="Primary"
          value="primary"
          svgId="primaryEmotionsBreakdown"
          loading={primaryEmotionsBreakdownLoading}
          link={`/report/primary-emotions?reportUrl=${reportUrl}`}
          height={230}
          legendHeight="235px"
          minHeight="340px"
          footer
          error={primaryEmotionsBreakdownError}
        />
        <PieChartWrapper
          title="Sentiment Breakdown"
          data={sentimentBreakdown}
          valueName="Sentiment"
          value="sentiment"
          svgId="sentimentBreakdown"
          loading={sentimentBreakdownLoading}
          link={`/report/sentiment?reportUrl=${reportUrl}`}
          height={180}
          minHeight="285px"
          legendHeight="150px"
          footer
          error={sentimentBreakdownError}
        />
      </Fragment>
    )
  }
}


export default ChartsComponent;


// WEBPACK FOOTER //
// ./src/modules/charts/charts-component.js